const convertToSpanishOrdinal = (number: number): string => {
  if (number < 0 || !Number.isInteger(number)) {
    throw new Error("Input must be a non-negative integer");
  }

  const lastDigit = number % 10;
  const secondToLastDigit = Math.floor((number % 100) / 10);

  if (secondToLastDigit === 1) {
    return `${number}th`; // Special case for numbers ending in 11, 12, and 13
  }

  let suffix = "";
  switch (lastDigit) {
    case 1:
      suffix = "er";
      break;
    case 2:
      suffix = "do";
      break;
    case 3:
      suffix = "er";
      break;
    default:
      suffix = "to";
  }

  return `${number}${suffix}`;
};

export default convertToSpanishOrdinal;
